// extracted by mini-css-extract-plugin
export var chevronIcon = "_e5-2";
export var teamName = "_e5-1";
export var teamSwitcherButton = "_e5-0";